import { Component, ContentChild, ElementRef, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { IconItemParentInterface } from './icon-item-parent.interface';

@Component({
  selector: 'wfm-icon-item',
  templateUrl: './icon-item.component.html',
  styleUrls: ['./icon-item.component.scss']
})
export class IconItemComponent implements OnChanges {
  @Input() icon: string;
  @Input() label: string;
  @Input() hidden = false;
  @Input() fillColor = '';
  @Input() class = '';
  @Input() tooltip: TemplateRef<any> | string = undefined;
  @Input() tooltipData: any = undefined;

  @ContentChild(TemplateRef) template: TemplateRef<any>;

  parent: IconItemParentInterface = undefined;

  get isHidden(): boolean {
    return this.element.nativeElement.children.length === 0;
  }

  constructor(public element: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    (!!changes.hidden || !!changes.icon) && this.parent && this.parent.itemVisibilityChanged();
  }
}
